import { Button, Typography } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import { ReactComponent as SparklesIcon } from "../../../icons/Advisor/Sparkles.svg";
import useIsMobile from "components/hooks/useIsMobile";
import { AgentPrompt } from "protogen/agents_service_pb";

const MagicDocButton = ({
  magicDoc,
  familyRef,
}: {
  magicDoc: AgentPrompt;
  familyRef?: string;
}) => {
  const params = new URLSearchParams();
  params.set("prompt", magicDoc.ref);
  if (familyRef) {
    params.set("family", familyRef);
  }
  params.set("autoRun", "1");
  const href = `/prompts?${params.toString()}`;

  return (
    <Button
      href={href}
      variant="text"
      startIcon={<SparklesIcon />}
      sx={{
        height: "auto",
        lineHeight: "1.3",
        alignItems: "start",
        justifyContent: "start",
        "& .MuiButton-startIcon": { marginLeft: "0" },
      }}
    >
      {magicDoc.name}
    </Button>
  );
};

interface Props {
  flex: number;
  familyRef?: string;
  magicDocs?: AgentPrompt[];
}

export default ({ flex, familyRef, magicDocs }: Props) => {
  const isMobile = useIsMobile();

  if (!magicDocs || magicDocs.length === 0) {
    return null;
  }

  return (
    <FlexBox variant="contained" direction="column" sx={{ flex: flex }}>
      <Typography variant={isMobile ? "h3" : "h4"}>Magic docs</Typography>
      <FlexBox direction="column" gap="8px">
        {magicDocs.map((doc) => (
          <MagicDocButton key={doc.ref} magicDoc={doc} familyRef={familyRef} />
        ))}
      </FlexBox>
    </FlexBox>
  );
};
